module.exports = __webpack_public_path__ + "img/p5.1dbed708.png";